import { createFileRoute } from '@tanstack/react-router'

import { DashboardTaskManagementActionCompletedPage } from '@/pages/_app/dashboard/task-management/action-completed/page'

import { FilterCondition } from '@/lib/queries/business/v1/task/search/types'

export interface ValidatedSearchParams {
  keyword?: string
  assignees?: string[]
  assigneeCondition?: FilterCondition
}

export const Route = createFileRoute('/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed')({
  component: DashboardTaskManagementActionCompletedPage,
  validateSearch: (searchParams): ValidatedSearchParams => {
    return {
      keyword: (searchParams.keyword as string) ?? undefined,
      assignees: (searchParams?.assignees as string[]) ?? undefined,
      assigneeCondition:
        searchParams.assigneeCondition === FilterCondition.and || searchParams.assigneeCondition === FilterCondition.or
          ? searchParams.assigneeCondition
          : undefined,
    }
  },
})
